export const PROPERTIES_ROUTES = [
  '/properties/:promoId/promo/properties/:propertyId',
  '/properties/:propertyId',
  '/properties-list',
  '/properties-filter',
];
